import React from 'react';
import classnames from 'classnames';
import styles from './PlusMinusToggle.module.scss';

interface Props {
  active: boolean;
  color?: string;
  useSmallIcon?: boolean;
}

export const PlusMinusToggle: React.FC<Props> = ({ active, color = 'black', useSmallIcon }) => {
  return (
    <div className={classnames(styles.iconPlus, { [styles.opened]: active, [styles.closed]: !active })}>
      <div className={styles.iconWrapper}>
        <div className={useSmallIcon ? styles.horizontalSmall : styles.horizontal} style={{ backgroundColor: color }}></div>
        <div className={useSmallIcon ? styles.verticalSmall : styles.vertical} style={{ backgroundColor: color }}></div>
      </div>
    </div>
  );
};

export default PlusMinusToggle;
